import axios from 'axios'

class ImageBlockService {
  isValidImage (file) {
    const imageFormats = [ 'png', 'jpg', 'jpeg', 'svg', 'gif' ]
    return !!imageFormats.find((f) => file.name.includes(f))
  }

  async uploadImage (pageId, blockKey, file) {
    let { data } = await axios.post(`api/report/${pageId}/${blockKey}/image`, file, {
      headers: {
        'Content-Type': file.type
      }
    })
    return data
  }
}

export const imageBlockService = new ImageBlockService()
